import { useState } from "react";
import { ButtonPrimary } from "../../../components/NewButtons";
import { MutateKioskConfigurationDrawer } from "./MutateKioskConfigurationDrawer";

export const MutateKioskConfigurationSelector = () => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      <ButtonPrimary onClick={() => setModalOpen(true)} type="button">
        Create kiosk configuration
      </ButtonPrimary>
      <MutateKioskConfigurationDrawer
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
      />
    </div>
  );
};
